module.exports = __webpack_public_path__ + "static/media/sendwyre.7d8dc206.png";